module.exports = __webpack_public_path__ + "img/logo-dashboard.38cb2a32.jpg";